export function isValidNotificationImageUrl(url) {
  if (!url?.trim()) return true;

  try {
    const parsed = new URL(url.trim());
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}

export function getValidNotificationImageUrl(url) {
  if (!isValidNotificationImageUrl(url)) return undefined;
  return url?.trim() || undefined;
}

export function formatNotificationResult(result) {
  const firstFailure = result?.failures?.[0]?.error;
  const sentCount = result?.sentCount || 0;
  const failedCount = result?.failedCount || 0;

  if (result?.success && sentCount > 0) {
    let text = `Notification sent! ${sentCount} delivered.`;
    if (failedCount > 0) {
      text += ` ${failedCount} failed.`;
    }
    return text;
  }

  return firstFailure || result?.message || "Failed to send notification";
}
